import { QueryResult, useQuery } from '@apollo/client';
import GET_ME from '../../queries/me/get-me-query';
import type { Student } from '@monorepo/shared/src/graph/schema-generated-types-student';
import { TourName } from 'types';
const { REACT_APP_APP_NAME: appName } = process.env;
import { StoreTypename } from 'types';

const PRODUCT_FAMILY_ID = 12;

export type UserStoreState = {
  me?: Student;
  locale?: string;
  isAuthenticated: boolean;
  isAuthenticating: boolean;
};

export type UserStoreDispatch = {
  userRefetch: () => void;
};
export type UserStore = [UserStoreState, UserStoreDispatch];

export const getDefaultUserStoreState = (): any => ({
  __typename: StoreTypename.USER,
});

const useUserStore = (): UserStore => {
  const {
    data,
    loading,
    error,
    refetch: userRefetch,
  }: QueryResult = useQuery(GET_ME, {
    variables: {
      settingsWhere: { appName },
      classroomSettingsWhere: { appName },
      toursSettingsWhere: { tours: [TourName.ONBOARDING], viewed: false },
      licensesWhere: { productFamily: { id: PRODUCT_FAMILY_ID } },
      groupsWhere: { appId: 12 },
    },
  });

  const isAuthenticated = data?.studentSession.student && !error ? true : false;

  return [
    {
      me: data?.studentSession.student,
      isAuthenticated,
      isAuthenticating: loading,
    },
    {
      userRefetch,
    },
  ];
};

export default useUserStore;
